<template>
  <section v-bind:class="[showNavBar ? 'app-main' : 'no-nav-app-main']">
    <div class="container is-fluid is-marginless"
         v-bind:class="[showNavBar ? 'app-content' : 'no-nav-app-content']">
      <transition
        mode="out-in"
        enter-active-class="fadeIn"
        leave-active-class="fadeOut"
        appear
      >
        <router-view class="animated"></router-view>
      </transition>
    </div>
  </section>
</template>

<script>
  import Vue from 'vue'
  import Notification from 'vue-bulma-notification'
  
  const NotificationComponent = Vue.extend(Notification)
  
  const openNotification = (propsData = {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 45000,
    container: '.notifications'
  }) => {
    return new NotificationComponent({
      el: document.createElement('div'),
      propsData
    })
  }
  
  export default {
    components: {
      Notification
    },

    data () {
      return {
      }
    },

    computed: {
      notification () {
        return this.$store.state.notification.nextNotification
      },
      currentRoute () {
        return this.$store.state.route.name
      },
      showNavBar () {
        return this.$store.state.config.navbar
      }
    },

    created: function () {
      this.setNavBarState(this.currentRoute)
    },

    methods: {
      openNotificationWithData (title = '', message = '', type = 'danger') {
        openNotification({
          title: title,
          message: message,
          type: type
        })
      },
      setNavBarState (route) {
        let showNavBar = this.$store.state.config.navbar

        if (route === 'Login') {
          if (showNavBar) {
            this.$store.dispatch('setNavbar', false)
          }
        } else {
          if (!showNavBar) {
            this.$store.dispatch('setNavbar', true)
          }
        }
      }
    },

    watch: {
      notification: function (val) {
        if (val) {
          this.openNotificationWithData(val.title, val.message, val.type)
          this.$store.dispatch('nextNotification')
        }
      },
      currentRoute: function (val) {
        this.setNavBarState(val)
      }
    }
  }
</script>

<style lang="scss">
  @import '~bulma/sass/utilities/variables';
  @import '~bulma/sass/utilities/mixins';

  
  .app-main {
    padding-top: 52px;
    transform: translate3d(0, 0, 0);
  }

  .app-content {
    padding: 20px;
  }
  
  .no-nav-app-main {
    padding-top: 0;
  }

  .no-nav-app-content {
    padding: 0;
  }

  .notifications {
    position: fixed;
    // top: 50px;
    top: initial !important;
    bottom: 0 !important;
    right: 0;
    z-index: 1990;
    pointer-events: none;
  }

  .notification .title {
    margin-bottom: 5px;
  }

  .dropzone .dz-preview .dz-error-message {
    font-size: 11px !important;
  }

  .font-weight-light {
    font-weight: 100
  }
</style>



// WEBPACK FOOTER //
// AppMain.vue?56ba732a